export default __webpack_public_path__ + "static/media/h_icon2.ed51298f.png";